var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_html.js
// module id = 125
// module chunks = 0